import { Provider } from '@angular/core';
import {
  ZOP_MANUFACTURING_ROUTE_CONFIG,
  ZopManufacturingRouteConfig,
} from '../services/routing/manufacturing-route-config';

/**
 * Provides manufacturing route configuration (BOM / material requirements base paths) for the
 * application. Only needed when the app shell mounts these routes somewhere other than the
 * top-level default — see `DEFAULT_MANUFACTURING_ROUTE_CONFIG`.
 *
 * @param config - Manufacturing route configuration object
 * @returns Provider for manufacturing route configuration
 *
 * @example
 * ```typescript
 * // In app.config.ts
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideZopManufacturingRoutes({
 *       materialRequirementsBasePath: '/work-management/material-requirements',
 *     }),
 *     // ... other providers
 *   ]
 * };
 * ```
 */
export const provideZopManufacturingRoutes = (config: ZopManufacturingRouteConfig): Provider => {
  return {
    provide: ZOP_MANUFACTURING_ROUTE_CONFIG,
    useValue: config,
  };
};
